// extracted by mini-css-extract-plugin
module.exports = {"container":"Wrapper_container__1yYrC","logoAlt":"Wrapper_logoAlt__2d3Ry","titleContainer":"Wrapper_titleContainer__2ZhCw"};